import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getFaqs } from "../../services/Faq";

const FAQ = () => {
    const [openIndex, setOpenIndex] = useState<number | null>(null);
    const [faqData, setFaqData] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(true);

    const toggleFAQ = (index: number) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    useEffect(() => {
        getFaqs()
            .then(data => {
                const activeFaqs = data
                    .filter((faq: any) => faq.isActive)
                    .sort((a: any, b: any) => a.id - b.id);
                setFaqData(activeFaqs);
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching FAQ data:", error);
                setLoading(false);
            });
    }, []);

    return (
        <div className="bg-gradient-to-br from-gray-50 to-gray-100 min-h-screen font-sans">
            <section className="relative bg-gradient-to-r from-black via-gray-900 to-yellow-600 text-white py-24 px-6 text-center overflow-hidden">
                <div className="relative z-10 max-w-4xl mx-auto">
                    <h1 className="text-5xl md:text-6xl font-extrabold mb-6 tracking-tight">
                        Frequently Asked Questions
                    </h1>
                    <p className="text-lg text-gray-200 max-w-2xl mx-auto">
                        Have questions? We’ve got you covered. Find answers to the most
                        common questions about our tire services, installations, and online
                        ordering.
                    </p>
                </div>
            </section>

            <div className="flex flex-col min-h-[70vh]">
                <div className="flex-1 max-w-4xl mx-auto my-5 w-full">
                    {loading ? (
                        <div className="flex flex-col items-center justify-center py-16">
                            <div className="w-10 h-10 border-4 border-gray-300 border-t-yellow-500 rounded-full animate-spin mb-4"></div>
                            <p className="text-gray-600 text-lg font-medium">Loading FAQs...</p>
                        </div>
                    ) : faqData.length === 0 ? (
                        <p className="text-center py-10 text-gray-600">No FAQs available.</p>
                    ) : (
                        faqData.map((faq, index) => (
                            <div
                                key={faq.id}
                                className="bg-white shadow-md rounded-xl mb-4 border border-gray-200 overflow-hidden"
                            >
                                <button
                                    onClick={() => toggleFAQ(index)}
                                    className="w-full flex justify-between items-center px-6 py-4 text-left text-lg font-semibold text-gray-800 hover:bg-gray-100 transition"
                                >
                                    <span className="flex-1 pr-6">{faq.question}</span>
                                    <span className="text-yellow-500 text-2xl">
                                        {openIndex === index ? "−" : "+"}
                                    </span>
                                </button>

                                {openIndex === index && (
                                    <div className="px-6 pb-4 text-gray-600 text-base leading-relaxed">
                                        {faq.answer}
                                    </div>
                                )}
                            </div>
                        ))
                    )}
                </div>

                <section className="bg-yellow-500 text-black py-16 text-center mt-auto">
                    <h3 className="text-3xl md:text-4xl font-bold mb-4">
                        Still have questions?
                    </h3>
                    <p className="text-lg mb-6">
                        Reach out to our support team — we’re here to help!
                    </p>
                    <Link
                        to="/contact-us"
                        className="inline-block bg-black text-yellow-400 px-6 py-3 rounded-full font-semibold hover:bg-gray-800 transition"
                    >
                        Contact Us →
                    </Link>
                </section>
            </div>
        </div>
    );
};

export default FAQ;